import React from 'react';
import { useMediaQuery } from '@mui/material';
import { Clock } from 'lucide-react';

// Step "Horarios"
const Step2Icon = ({ color }) => {
    const matches = useMediaQuery('(min-width:600px)');
    return <Clock color={color} size={matches ? 25 : 20} strokeWidth={2.1} />;
};

export default Step2Icon;
